import api from 'api'
import { defaultHandleError } from 'util/downloadFile'
import { previewFile } from 'util/previewFile'

import { AtestadoImpressaoInput, AtestadoImpressaoWrapperModel, AtestadoRecenteImpressaoInput } from '../model-atestado'

export const downloadAtestado = (inputWrapper: AtestadoImpressaoWrapperModel, isTreinamento: boolean) => {
  const input: AtestadoImpressaoInput = {
    id: inputWrapper.id,
    prontuarioId: inputWrapper.prontuarioId,
    atendimentoId: inputWrapper.atendimentoId,
  }
  return api.atestado
    .imprimirAtestado(input)
    .then((res) => generatePdfFromResponse(res, isTreinamento))
    .catch(defaultHandleError)
}

export const downloadAtestadoRecente = (inputWrapper: AtestadoImpressaoWrapperModel, isTreinamento: boolean) => {
  const input: AtestadoRecenteImpressaoInput = {
    descricao: inputWrapper.atestadoModel.descricao,
    tipo: inputWrapper.atestadoModel.tipo,
    prontuarioId: inputWrapper.prontuarioId,
    atendimentoId: inputWrapper.atendimentoId,
    atendimentoProfissionalIniciadoEm: inputWrapper.atendimentoProfissionalIniciadoEm,
  }

  return api.atestado
    .imprimirAtestadoRecente(input)
    .then((res) => generatePdfFromResponse(res, isTreinamento))
    .catch(defaultHandleError)
}

function generatePdfFromResponse(response, isTreinamento: boolean) {
  previewFile(
    new Blob([response.data], { type: 'application/pdf' }),
    `Atestado_${new Date().getTime()}${isTreinamento ? '_treinamento' : ''}.pdf`
  )
  return response
}
